const fourColumnData = [
  {
    indexId: "7)",
    sampleId: "",
    date: "",
    time: "",
    location: "",
    matrix: "",
    type: "",
    size: "",
    containerType: "",
    preservation: "",
    numContainers1: "",
    epaMethod: "",
    aof: "",
    hrms: "",
    msms: "",
    notes: "",
  },
  {
    indexId: "8)",
    sampleId: "",
    date: "",
    time: "",
    location: "",
    matrix: "",
    type: "",
    size: "",
    containerType: "",
    preservation: "",
    numContainers1: "",
    epaMethod: "",
    aof: "",
    hrms: "",
    msms: "",
    notes: "",
  },
  {
    indexId: "9)",
    sampleId: "",
    date: "",
    time: "",
    location: "",
    matrix: "",
    type: "",
    size: "",
    containerType: "",
    preservation: "",
    numContainers1: "",
    epaMethod: "",
    aof: "",
    hrms: "",
    msms: "",
    notes: "",
  },
  {
    indexId: "10)",
    sampleId: "",
    date: "",
    time: "",
    location: "",
    matrix: "",
    type: "",
    size: "",
    containerType: "",
    preservation: "",
    numContainers1: "",
    epaMethod: "",
    aof: "",
    hrms: "",
    msms: "",
    notes: "",
  },
];

export default fourColumnData;